import { PropsWithChildren } from "react";

import { ReviewDataContext, useCreateReviewData } from "@components/QaReview/hooks/useReviewData";

export const ReviewDataProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <ReviewDataContext value={useCreateReviewData()}>{children}</ReviewDataContext>
);
